import { breakpoints as iParqueBreakpoints } from "iparque-components";

export const breakpoints = iParqueBreakpoints;
